import BillingInfoIcon from "public/cyber-security/edrmdrxdr/stash_billing-info.svg";
import SupportIcon from "public/cyber-security/edrmdrxdr/material-symbols_support.svg";
import RefreshIcon from "public/cyber-security/edrmdrxdr/charm_refresh.svg";
import ComplianceIcon from "public/cyber-security/edrmdrxdr/grommet-icons_compliance.svg";
import CubeImg from "public/cyber-security/edrmdrxdr/bxs_cube.svg";
import AnalyticsIcon from "public/cyber-security/edrmdrxdr/mdi_google-analytics.svg";

export const WHY_ONEMIND_CONSTANTS = {
  TITLE: "Why Security Teams Choose OneMind for Compliance & SEC OPS ",
  ITEMS: [
    {
      image: AnalyticsIcon,
      title: "Automate Compliance Audits",
      content:
        "AI-powered tools validate security controls and generate real-time compliance reports without manual effort.",
    },
    {
      image: CubeImg,
      title: "Ensure Adherence to Industry Standards",
      content:
        "Stay compliant with GDPR, PCI-DSS, ISO 27001, NIST, and SOC 2 — all from a centralized platform.",
    },
    {
      image: ComplianceIcon,
      title: "Strengthen Security Operations (SEC OPS)",
      content:
        "Automated orchestration minimizes human error and improves incident response times across hybrid environments.",
    },
    {
      image: RefreshIcon,
      title: "Detect & Respond to Compliance Violations",
      content:
        "Real-time SIEM monitoring flags violations early to keep your regulatory posture intact.",
    },
    {
      image: SupportIcon,
      title: "Reduce Costs & Avoid Compliance Fines",
      content:
        "Lower the risk of audit failures and regulatory penalties with proactive governance controls.",
    },
    {
      image: BillingInfoIcon,
      title: "Enhance Audit Readiness ",
      content:
        "Continuous monitoring ensures you're always audit-ready — no scrambling before deadlines.",
    },
  ],
};
